/*!
	Custom PlusPort scripts v1.0.0
	(c) 2015
*/

jQuery(document).ready(function ($) {
	$('.more').click(function () {
		$(this).fadeOut(300);

		$('.prod_extra')
			.removeClass('hide')
			.slideDown('slow', function () {
				$('.less').fadeIn(300);
				$('.prod_label.extra').fadeIn(400);
			});
	});
	$('.less').click(function () {
		$('.prod_label.extra').fadeOut(200);
		$(this).fadeOut(300);
		$('.prod_extra')
			.addClass('hide')
			.slideUp('slow', function () {
				$('.more').fadeIn(300);
			});
		$('html,body').animate(
			{
				scrollTop: $('.productwrapper').offset().top,
			},
			'slow'
		);
	});

	/*--- slicknav */
	var colorThemePrimary = $('.primary-theme-btn').css('background-color');
	var height = $(window).height();

	$('#menu-main').slicknav({
		label: 'Menu',
		duration: 300,
		allowParentLinks: 'true',
		closedSymbol: '<i class="fa fa-chevron-right" aria-hidden="true"></i>',
		openedSymbol: '<i class="fa fa-chevron-up" aria-hidden="true"></i>',

		beforeOpen: function (trigger) {
			$('.slicknav_menu').css('border-color', colorThemePrimary);
			$('.slicknav_menu').css({
				'max-height': height,
				'overflow-y': 'scroll',
			});
		},
		afterClose: function (trigger) {
			if (trigger[0].className === 'slicknav_btn slicknav_collapsed') {
				$('.slicknav_menu').css('border-color', '');
				$('.slicknav_menu').css('max-height', '');
				$('.slicknav_menu').css('overflow-y', '');
			}
		},
	});
	if ($('html').attr('lang') === 'en-GB') {
		$('.slicknav_menu').append(
			'<a class="belBar" href="tel:+31703229090">Call us</a>'
		);
	} else {
		$('.slicknav_menu').append(
			'<a class="belBar" href="tel:+31703229090">Bel ons direct</a>'
		);
	}
	$('.slicknav_menu').prepend('<a class="logo" href="/"></a>');
	if ($('html').attr('lang') === 'en-GB') {
		$('.slicknav_menu').prepend(
			'<div class="topbar clr"><a href="/enrol" class="btnInschrijven">Enrol now</a><a href="https://direct.plusport.com" target="_blank" rel="nofollow noopener noreferrer" class="btnInloggen">Log in</a><a href="tel:+31703229090" class="btnBel">Call us</a></div>'
		);
	} else {
		$('.slicknav_menu').prepend(
			'<div class="topbar clr"><a href="/inschrijven" class="btnInschrijven">Boek cursus</a><a href="https://direct.plusport.com" target="_blank" rel="nofollow noopener noreferrer" class="btnInloggen">Inloggen</a><a href="tel:+31703229090" class="btnBel">Bel ons</a></div>'
		);
	}
	/*--- /slicknav */

	// --- hide and close FAQ
	$('#faq .no-margin ul.list li h4.name>span').click(function () {
		$(this).toggleClass('close');
		$(this).parent('h4').nextAll().slideToggle(200);
	});

	//  --- Reload / reset / hide elements on sort
	$('button.reset').click(function () {
		location.reload();
	});

	$('button.sort').click(function () {
		$('.list h2 ').hide();
	});

	// --- table responsive 3 column
	var test = $(window).width();
	if (test < 768 && window.innerHeight > window.innerWidth) {
		if ($('body:not(.page-id-3647) div.page article.page .no-margin:first').find('table').length > 0) {
			$('div.page article.page .no-margin:first table').addClass('first');
			$('div.page article.page .no-margin:first table.first')
				.clone()
				.addClass('clone')
				.removeClass('first')
				.insertAfter('div.page article.page .no-margin:first table.first');
			//$("table.first td:first-child").remove();
			//$("table.clone td").not('td:first-child').remove();
			$('table.clone').insertBefore($('table.first'));
			$('table.first, table.clone').wrapAll('<div class="table-container" />');
			$('table.first').wrapAll('<div class="table-column2" />');
			$('table.clone').wrapAll('<div class="table-column1" />');

			var firstColumn = $('table.clone td:first-child').outerWidth();
			$('.table-column1').width(firstColumn + 1);
			$('.table-column2 table.first td:first-child').hide();

			var tableContainerWidth = $('.table-container').outerWidth();
			var tableColumn1Width = $('.table-column1').outerWidth();
			var tableColumn2Width = tableContainerWidth - tableColumn1Width;

			$('.table-column2').width(tableColumn2Width);

			$('.table-container').prepend('<div class="scroll-tags"></div>');
			$('.table-container').append('<div class="scroll-tags below"></div>');
			$('.scroll-tags').css({
				marginLeft: tableColumn1Width + 'px',
				width: tableColumn2Width + 'px',
			});
			$('.table-column1 table tr').each(function (i) {
				$('.table-column2 table tr').eq(i).height($(this).outerHeight());
			});
		}
	}

	$('ul.list li.anchor_faq a').click(function () {
		var faqSearch = $(this).text();
		var Input = $('article#faq input.search');
		var search = {
			list: function () {
				for (var k = 0, kl = list.items.length; k < kl; k++) {
					search.item(list.items[k]);
				}
			},
			item: function (item) {
				item.found = false;
				for (var j = 0, jl = columns.length; j < jl; j++) {
					if (search.values(item.values(), columns[j])) {
						item.found = true;
						return;
					}
				}
			},
			values: function (values, column) {
				if (values.hasOwnProperty(column)) {
					text = toString(values[column]).toLowerCase();
					if (searchString !== '' && text.search(searchString) > -1) {
						return true;
					}
				}
				return false;
			},
			reset: function () {
				list.reset.search();
				list.searched = false;
			},
		};
		$('article#faq input.search').val(faqSearch).search(faqSearch);
	});

	$(
		'.nivo-caption .grid-container .grid-15.ml-caption:first a button.primary-theme-btn'
	).css('float', 'right');

	// --- submenu children
	if (
		$('.submenu ul li.page_item_has_children').hasClass('current_page_parent')
	) {
		$(
			'.submenu ul li.page_item_has_children.current_page_parent >  ul.children'
		).addClass('show');
		$(
			'.submenu ul li.page_item_has_children.current_page_parent > ul.children'
		).wrap('<div class="sub-submenu">');
	}
	if (
		$('.submenu ul li.page_item_has_children').hasClass('current_page_item')
	) {
		$(
			'.submenu ul li.page_item_has_children.current_page_item >  ul.children'
		).addClass('show');
		$(
			'.submenu ul li.page_item_has_children.current_page_item > ul.children'
		).wrap('<div class="sub-submenu">');
	}
	if (
		$('.submenu ul li.page_item_has_children').not('.current_page_item') &&
		$('.submenu ul li.page_item_has_children').not('current_page_parent')
	) {
		$('.submenu ul li.page_item_has_children > ul.children').removeClass(
			'show'
		);
		$('.submenu ul li.page_item_has_children >  ul.children').addClass('hide');
	}
	if ($('.sub-submenu')[0]) {
		var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
		// if (width >= 1230) {
		if (width >= 1060) {
			$('.row.content.sub').css('border-top-width', 'thin');
			$('.row.content.sub').css('border-top-style', 'solid');
			$('.row.content.sub').css('margin-top', '50px');
		}
	}

	//fancyBox

	$('a.PopUp').fancybox({
		width: '1009px',
		height: '75%',
		autoScale: true,
		transitionIn: 'none',
		transitionOut: 'none',
		type: 'iframe',
	});

	// quick subscribe with dropdown
	var qsWidth = $('.pp_component.QuickSubscribe li[id^=dropdown-]').width();

	$('.pp_component.QuickSubscribe li[id^=dropdown-] ul.dropdown-menu').css(
		'width',
		qsWidth + 'px'
	);

	// --- fix duplicate sends (test vcadirect.nl) 1/2
	// https://stackoverflow.com/questions/49433946/contact-form-7-add-disabled-attr-to-button-to-prevent-double-submission?rq=1
	$('.wpcf7-submit').click(function () {
		jQuery(this).attr('disabled', true);
		jQuery(this).submit();
	});
	// --- /fix duplicate sends (test vcadirect.nl) 1/2

	// end ready
});

// --- fix duplicate sends (test vcadirect.nl) 2/2
// This will re-enable the button if there's an error with the submission.
document.addEventListener('wpcf7invalid', function () {
	jQuery('.wpcf7-submit').attr('disabled', false);
}, false);
// --- /fix duplicate sends (test vcadirect.nl) 2/2


var categoriesReordered = false;

jQuery(document).ready(function ($) {
	$(document).ajaxComplete(function () {

		$("#dropdown-categories").click(function () {
			var categoryIDs = [0, 5, 6, 9, 7, 8, 4, 2, 1, 3];

			categoryIDs.forEach((categoryID) => {

				$('#dropdown-categories').find('a[data-value="' + categoryID + '"]').parent().prependTo("#dropdown-categories .dropdown-menu");
			});
		});
	});
})

$(window).on('scroll', function () {
	var scrollTop = $(window).scrollTop();
	if (scrollTop > 140) {
		$('.top-menu').addClass('top-menu--compact');
	}
	else {
		$('.top-menu').removeClass('top-menu--compact');
	}
});

jQuery(document).ready(function ($) {
	$(document).ajaxComplete(function () {
		$('.quick-subscribe__options .dropdown').on('show.bs.dropdown', function () {
			$('.quick_subscribe.row').css('z-index', 1000);
		});

		$('.quick-subscribe__options .dropdown').on('hide.bs.dropdown', function () {
			$('.quick_subscribe.row').css("z-index", '');
		});

		if ($('html').attr('lang') == 'en-GB') {
			$('.quick-subscribe__label').html('Enrol now <div class="quick-subscribe__arrow"></div>');
		}


	});


});